import { FC, useState, useEffect } from "react";
import { Gizmo, useGizmo } from "flowy-3-core";
import dayjs from "dayjs";
import * as S from "./DateField.styles";
import { GizmoWrapper } from "../../utils";
import 'dayjs/locale/es'
import locale from "antd/es/date-picker/locale/es_ES";

type DateFieldProps = {
  gizmo: Gizmo;
};

const DateField: FC<DateFieldProps> = ({ gizmo }) => {
  const { features, binder, errors, config } = useGizmo({ gizmo });
  const [value, setValue] = useState<string>("");
  const [format, setFormat] = useState<string>('');

  const handleChange = async (_date: unknown, valueString: string | string[]) => {
    const next = Array.isArray(valueString) ? valueString[0] ?? "" : valueString;
    await binder?.setValue(next);
  };

  useEffect(() => {
    if (binder) {
      const initValue = binder.getValue();
      setFormat(binder.getFormat())
      if (initValue) {
        setValue(initValue);
      }
      binder.value.subscribe((v: string) => {
        setValue(v);
      });
    }
  }, [binder]);

  return (
    <GizmoWrapper features={features} errors={errors}>
      {!features.editable ? (
        <span>{value}</span>
      ) : (
        <S.DateField
          id={`date_field-${config.fid}`}
          onChange={handleChange}
          placeholder={format}
          value={value?.length ? dayjs(value, format) : undefined}
          format={format}
          locale={locale}
        />
      )}
    </GizmoWrapper>
  )
};

export default DateField;
